import PillarForm from "shared/components/pillar-form/PillarForm";
import { usePillarTableContext } from "shared/components/pillar-table/PillarTableContext";
import { type PillarTableSafeAny } from "shared/components/pillar-table/PillarTableSafeAny";
import { usePillarTableRowContext } from "shared/components/pillar-table/row/PillarTableRowContext";

const PillarTableRowInlineDelete = <
  RowGeneric = PillarTableSafeAny,
  ExtraPropsGeneric = PillarTableSafeAny | undefined,
  InlineEditFormGeneric = PillarTableSafeAny | undefined,
>() => {
  const { testidTable, handleInlineDelete, refetchData } =
    usePillarTableContext<
      RowGeneric,
      ExtraPropsGeneric,
      InlineEditFormGeneric
    >();
  const { rowIndex, inlineEditMode, setInlineEditMode, rowValue } =
    usePillarTableRowContext<
      RowGeneric,
      ExtraPropsGeneric,
      InlineEditFormGeneric
    >();
  if (!refetchData || !handleInlineDelete || inlineEditMode === "edit") {
    return <></>;
  }
  if (inlineEditMode === "none") {
    return (
      <td
        data-testid={
          testidTable
            ? `${testidTable}-table-body-row-column-inlineDelete`
            : undefined
        }
        key={`row-${rowIndex}-column-inlineDelete`}
        className="whitespace-nowrap pillartable-table-cell-general "
      >
        <div className="flex gap-x-1 break-words overflow-visible whitespace-normal">
          <div className="">
            <PillarForm.Button
              className="flex items-center justify-center gap-x-0.5 button-small-destructive-filled"
              testid={"delete-button"}
              onClick={(event) => {
                setInlineEditMode("delete");
                event.stopPropagation();
              }}
            >
              Delete
            </PillarForm.Button>
          </div>
        </div>
      </td>
    );
  }
  if (inlineEditMode === "delete" || inlineEditMode === "deleting") {
    return (
      <td
        data-testid={
          testidTable
            ? `${testidTable}-table-body-row-column-inlineDelete`
            : undefined
        }
        key={`row-${rowIndex}-column-inlineDelete`}
        className="whitespace-nowrap pillartable-table-cell-general"
      >
        <PillarForm.Button
          className="button-small-neutral-filled mr-1 mb-1"
          testid="cancel-button"
          disabled={inlineEditMode === "deleting"}
          onClick={(event) => {
            setInlineEditMode("none");
            event.stopPropagation();
          }}
        >
          Cancel
        </PillarForm.Button>
        <PillarForm.Button
          className="button-small-destructive-filled"
          testid="confirm-delete-button"
          disabled={inlineEditMode === "deleting"}
          onClick={async (event) => {
            setInlineEditMode("deleting");
            event.stopPropagation();
            // `false` or a throw means nothing was deleted: put the row back
            // to its normal state so it is not stuck on disabled buttons.
            // `undefined` still counts as success for handlers returning void.
            let deleted = false;
            try {
              deleted =
                (await handleInlineDelete(rowValue, refetchData)) !== false;
            } catch (error) {
              console.error(error);
            } finally {
              if (!deleted) {
                setInlineEditMode("none");
              }
            }
            if (deleted) {
              await refetchData();
            }
          }}
        >
          Confirm Delete
        </PillarForm.Button>
      </td>
    );
  }
  return (
    <td
      data-testid={
        testidTable
          ? `${testidTable}-table-body-row-column-inlineDelete`
          : undefined
      }
      key={`row-${rowIndex}-column-inlineDelete`}
      className="whitespace-nowrap pillartable-table-cell-general"
    ></td>
  );
};

export default PillarTableRowInlineDelete;
